export const getStoreAddressString = (address) => {
  return [
    address?.door_number,
    address?.line1,
    address?.line2,
    address?.city_town,
    address?.county,
    address?.postcode,
  ]
    .filter((info) => !!info)
    .join(" ");
};
